"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescriptionRequestStatusCode = exports.PrescriptionRequestType = exports.PrescriptionRequestDeliveryType = void 0;
var PrescriptionRequestDeliveryType;
(function (PrescriptionRequestDeliveryType) {
    PrescriptionRequestDeliveryType["Online"] = "delivery-online";
    PrescriptionRequestDeliveryType["Doctor"] = "delivery-doctor";
    PrescriptionRequestDeliveryType["Post"] = "delivery-post";
    PrescriptionRequestDeliveryType["Digital"] = "delivery-digital";
    PrescriptionRequestDeliveryType["Offline"] = "delivery-offline";
})(PrescriptionRequestDeliveryType || (exports.PrescriptionRequestDeliveryType = PrescriptionRequestDeliveryType = {}));
var PrescriptionRequestType;
(function (PrescriptionRequestType) {
    PrescriptionRequestType["prescription"] = "prescription";
    PrescriptionRequestType["medication"] = "medication";
})(PrescriptionRequestType || (exports.PrescriptionRequestType = PrescriptionRequestType = {}));
var PrescriptionRequestStatusCode;
(function (PrescriptionRequestStatusCode) {
    PrescriptionRequestStatusCode["ZurRose"] = "zurrose";
    PrescriptionRequestStatusCode["Pickup"] = "pickup";
    PrescriptionRequestStatusCode["NoNewPatient"] = "noNewPatient";
    PrescriptionRequestStatusCode["Post"] = "post";
    PrescriptionRequestStatusCode["ContactPractice"] = "contactPractice";
    PrescriptionRequestStatusCode["Other"] = "other";
})(PrescriptionRequestStatusCode || (exports.PrescriptionRequestStatusCode = PrescriptionRequestStatusCode = {}));
//# sourceMappingURL=prescriptionRequests.js.map